import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import { LandingPage } from './presentation/pages/LandingPage/LandingPage';

function App() {
  return (
    <div className="App">
      <LandingPage />
    </div>
  );
}

export default App;
